import { AxiosError } from 'axios';
import { TrackingGender } from 'rlv-common';
export interface TrackingContent {
  event?: TrackingEvents;
  page: TrackingPage;
  product: TrackingProduct[];
  transaction: TrackingTransaction;
  eventdetails?: TrackingEventDetails;
  user?: TrackingUser[];
  miscellaneous?: TrackingMiscellaneous;
}
export interface TrackingWindow extends Window {
  appEventData: TrackingContent[];
}

export enum TrackingEvents {
  PAGE_LOAD = 'PageLoaded',
  GENERAL_CLICK = 'GeneralClick',
}

export enum TrackingEnvironments {
  DEVELOP = 'develop',
  PRODUCTION = 'prod',
}

export enum TrackingPagename {
  LEGAL_QUESTIONS_SUMMARY_OFFLINE_PAGE = 'LegalQuestionsSummaryOfflinePage',
  FEE_BEFORE_DUW_PAGE = 'FeeBeforeDuwPage'
}

export enum TrackingElementBasic {
  BUTTON_NEXT = 'Btn_Weiter',
  BUTTON_BACK = 'Btn_Zurueck',
}

export enum TrackingElementNeedSelection {
  RADIOBUTTON_FALLING_SUM = 'RB_FallendeVersicherungssumme',
  RADIOBUTTON_CONSTANT_SUM = 'RB_KonstanteVersicherungssumme',
}

export enum TrackingElementDivergingInsuredPerson {
  RADIOBUTTON_SELF = 'RB_MichSelbst',
  RADIOBUTTON_DIVERGING = 'RB_EineAnderePerson',
}

export enum TrackingElementSmoker {
  RADIOBUTTON_SMOKER = 'RB_RaucherJa',
  RADIOBUTTON_NONSMOKERLESS10 = 'RB_RaucherNeinLess10',
  RADIOBUTTON_NONSMOKERMIN10 = 'RB_RaucherNeinMin10',
}

export enum TrackingElementGender {
  RADIOBUTTOM_MALE = 'RB_Mann',
  RADIOBUTTION_FEMALE = 'RB_Frau',
}

export enum TrackingElementMotorbike {
  RADIOBUTTON_BIKER = 'RB_MotorradJa',
  RADIOBUTTON_NOT_BIKER = 'RB_MotorradNein',
}

export enum TrackingElementInsuranceStart {
  RADIOBUTTON_DATE_TOP = 'RB_DateTop',
  RADIOBUTTON_DATE_MIDDLE = 'RB_DateMiddle',
  RADIOBUTTON_DATE_BOTTOM = 'RB_DateBottom',
}

export enum TrackingElementFeePage {
  RADIOBUTTON_PREMIUM = 'RB_Premium',
  RADIOBUTTON_KOMFORT = 'RB_Komfort',
  RADIOBUTTON_BASIC = 'RB_Basis',
  BUTTON_ALL_BENEFITS = 'Btn_AlleLeistungen',
  CHECKBOX_DREAD_DISEASE = 'Checkbox_DreadAndDisease',
  CHECKBOX_SECURITY_PLUS = 'Checkbox_SicherheitPlus',
  CHECKBOX_DYNAMIC_PAYMENT = 'Checkbox_Beitragsdynamik',
  DOWNLOAD_BENEFITS_PDF = 'Download_Leistungsübersicht',
  INFOICON_PAYMENT_NO_PERIOD = 'InfoIcon_AuszahlungSummeOhneWartezeit',
  INFOICON_BASIC_AFTER_INSURANCE = 'InfoIcon_ErhoehungSummeOhneErneuteGesundheitspruefung',
  INFOICON_PROVISIONAL_COVER = 'InfoIcon_VorlaeufigerVersicherungsschutz',
  INFOICON_EARLY_DEATH = 'InfoIcon_VorgezogeneTodesfallleistungbeischwererKrankheit',
  INFOICON_BENEFITS_FROM_BASIC = 'InfoIcon_AlleLeistungenAusGrundschutz',
  INFOICON_AFTER_INSURANCE = 'InfoIcon_ErwErhoehungSummeOhneErneuteGesundheitspruefung',
  INFOICON_TEMPORARY_INCREASE = 'InfoIcon_TempErhoehungSumme',
  INFOICON_HELP_FOR_RELATIVES = 'InfoIcon_SoforthilfeFuerAngehoerige',
  INFOICON_DREAD_DISEASE = 'InfoIcon_DreadAndDisease',
  INFOICON_SECRUITY_PLUS = 'InfoIcon_SicherheitPlus',
  INFOICON_DYNAMIC_PAYMENT = 'InfoIcon_BeitragsDynamik',
  INFOICON_BENEFITS_FROM_BASIC_AND_KONFORT = 'InfoIcon_InklAllerLeistungenGrundKomfortschutz',
  INFOICON_ORPHAN_PROTECTION = 'InfoIcon_MonatlWaisenschutzKindBis18Jahre',
  INFOICON_MEDICAL_OPINION = 'InfoIcon_VerlLaufzeit15JahreOhneErnGesundheitspruefung',
  INFOICON_BONUS_LIFETIME = 'InfoIcon_PflegebonusBis15000ZuLebzeiten',
  INFOICON_SECOND_OPINION = 'InfoIcon_KostenloseMedZweitmeinung',
  INFOICON_INSTANT_HELP = 'InfoIcon_SoforthilfeAngehörige',
  BUTTON_ONLINE_CONTRACT = 'Btn_OnlineAbschließen',
  BUTTON_REQUEST_OFFER = 'Btn_AngebotAnfordern',
  BUTTON_MORE_INFO = 'Link_MehrInfoZumBeitrag',
  INFOICON_DURATION = 'InfoIcon_Laufzeit',
  INFOICON_DEATH_BENEFIT = 'InfoIcon_Todesfallsumme',
}

export enum TrackingElementSigningPage {
  DIGITAL_SIGNATURE_ENTERED_SUCCESSFULLY = 'DigitalSignatureEnteredSuccessfully',
  BUTTON_WEITER = 'Btn_Weiter',
  BUTTON_ZURUECK = 'Btn_Zurueck',
  BUTTON_ONLINE_ABSCHLUSS_FORTSETZEN = 'Btn_OnlineAbschlussFortsetzen',
  BUTTON_ZURUECK_UND_NEU_UNTERSCHREIBEN = 'Btn_ZurueckUndNeuUnterschreiben',
  BUTTON_SIGN_SECURELY_NOW = 'Btn_JetztSicherUnterschreiben',
  ICON_SCHLIESSENX = 'Icon_SchliessenX',
}

export enum TrackingElementDUUPage {
  LOADED_DUU = 'DownloadUnterschriftEnUbertragen',
  BUTTON_UNTERLAGEN_HERUNTERLADEN = 'Btn_UnterlagenHerunterladen',
  BUTTON_ONLINE_BEANTRAGEN = 'Btn_OnlineBeantragen',
}

enum TrackingElementPersonalData {
  INFOICON_IBAN = 'InfoIcon_IBAN',
  BUTTON_SAVE_PERSON = 'Btn_PersonSpeichern',
}

export enum TrackingElementSubscriptions {
  RB_BEZUGSRECHT_JA = 'RB_BezugsrechtJa',
  RB_REZUGSRECHT_NEIN = 'RB_BezugsrechtNein',
  LNK_INFO_BEZUGSRECHT = 'Lnk_InfoBezugsrecht',
  LNK_ANSCHRIFT_VP_UEBERNEHMEN = 'Lnk_AnschriftVPÜbernehmen',
  INFO_ICON_LAND = 'InfoIcon_Land',
  BTN_PERSON_SPEICHERN = 'Btn_PersonSpeichern',
  LNK_PERSON_LOESCHEN = 'Lnk_PersonLöschen',
  LNK_PERSON_BEARBEITEN = 'Lnk_PersonBearbeiten',
  BTN_PERSON_HINZUFUEGEN = 'Btn_PersonHinzufügen',
}

export enum TrackingElementGWG {
  RB_GWG_YES = 'RB_GwgJa',
  RB_GWG_NO = 'RB_GwgNein',
  LINK_AGENT = 'Lnk_VermittlerFinden',
}

export enum TrackingElementLoanProtection {
  RB_LOAN_YES = 'RB_DarlehenJa',
  RB_LOAN_NO = 'RB_DarlehenNein',
}

export enum TrackingElementConsentDataProcessing {
  CHECKBOX_DATAPROCESSING = 'Checkbox_DatenverarbeitungJa',
  CHECKBOX_HEALTHDATA = 'Checkbox_WeitergabeGesundheitsdatenJa',
}

export enum TrackingElementConsentToReleasePrivateData {
  RADIOBUTTON_GENERAL = 'RB_AllgemeineSEE',
  RADIOBUTTON_SINGULAR = 'RB_EinzelfallSEE',
  CHECKBOX = 'Checkbox_SEE',
}

export enum TrackingElementSummary {
  ACCORDEON_TARIFF = 'Acc_TarifUndBeitrag',
  ACCORDEON_INSURANCE = 'Acc_Absicherungsbedarf',
  ACCORDEON_RISK = 'Acc_Risikoeinschätzung',
  ACCORDEON_HEALTH = 'Acc_Gesundheitsfragen',
  ACCORDEON_PERSONAL_DATA = 'Acc_PersönlicheDatenVersicherungsnehmer',
  ACCORDEON_INSURED_PERSON_DATA = 'Acc_PersönlicheDatenVersichertePerson',
  ACCORDEON_PAYMENT = 'Acc_Bankverbindung',
  ACCORDEON_INHERITANCE = 'Acc_BezugsberechtigtePersonen',
  BUTTON_DOWNLOAD = 'Btn_SofortDownload',
  BUTTON_POSTAL = 'Btn_AngebotPerPost',
  BUTTON_EMAIL = 'Btn_AngebotPerEmail',
}

export enum TrackingElementCreditCheck {
  CHECKBOX = 'Checkbox_BonitätJa',
}

export enum TrackingElementIDD {
  CHECKBOX_IDD = 'Checkbox_BeratungsverzichtJa',
  BUTTON_IDD_DOWNLOAD = 'Btn_IDDDownload',
  BUTTON_SEND = 'Btn_OnlineBeantragen',
  BUTTON_CONTINUE_WITH_SIGNATURE = 'Btn_WeiterZurUnterschrift',
}

export enum TrackingElementAfterSalesFeedback {
  BUTTON_DOWNLOAD_PDF = 'Btn_AngebotDownload',
}

export enum TrackingConversionTypes {
  SALE_FUNNEL_START = 'SaleFunnelStart',
  SALE_FUNNEL_PERSONAL_DATA = 'SaleFunnelPersonalData',
  SALE_FUNNEL_CALCULATION = 'SaleFunnelCalculation',
  SALE_FUNNEL_FINAL_CHECK = 'SaleFunnelFinalCheck',
  SALE = 'Sale',
  POSTAL = 'OfferPost',
  EMAIL = 'OfferEmail',
  PDF_DOWNLOAD = 'OfferPdfDownload',
}

export enum TrackingNeed {
  CONSTANT = 'KonstanteSumme',
  DECREASING = 'LinearFallendeSumme',
}

export type TrackingElement =
  | TrackingElementBasic
  | TrackingElementNeedSelection
  | TrackingElementDivergingInsuredPerson
  | TrackingElementSmoker
  | TrackingElementGender
  | TrackingElementMotorbike
  | TrackingElementInsuranceStart
  | TrackingElementFeePage
  | TrackingElementPersonalData
  | TrackingElementSubscriptions
  | TrackingElementGWG
  | TrackingElementLoanProtection
  | TrackingElementConsentDataProcessing
  | TrackingElementConsentToReleasePrivateData
  | TrackingElementSummary
  | TrackingElementCreditCheck
  | TrackingElementDUWDisclosure
  | TrackingElementIDD
  | TrackingElementAfterSalesFeedback
  | TrackingElementSigningPage
  | TrackingElementDUUPage;

interface TrackingPage {
  pageInfo: TrackingPageInfo;
  attributes: TrackingPageAttributes;
  category: TrackingPageCategory;
}

export enum TrackingBoolean {
  YES = 'J',
  NO = 'N',
}

interface TrackingPageInfo {
  pageName?: string;
  sysEnv: TrackingEnvironments;
  issueDate: string;
}

interface TrackingAgency {
  oenrNumber?: string;
  pnrNumber?: string;
}

interface TrackingMiscellaneous {
  errors?: TrackingError;
  agency?: TrackingAgency;
}

export interface TrackingError {
  errorFlag: true;
  errorType?: number | string; // TODO: analyze to unify in the string type
  errorMessages: string;
  errorUrl: string;
}

interface TrackingPageAttributes {
  displayedBrand: TrackingBrand;
  brokerModus: TrackingBrokerModus;
}

export interface NetworkError extends AxiosError {}

export enum TrackingBrand {
  ERGO = 'ERGO',
}

export enum TrackingBrokerModus {
  ON = 'On',
  OFF = 'Off',
}
interface TrackingPageCategory {
  pagePurpose: TrackingPagePurpose;
  primaryCategory: TrackingCategory;
}

export enum TrackingPagePurpose {
  SALE = 'Sale',
}

export enum TrackingCategory {
  RLV = 'risikolv2022',
}

interface TrackingProduct {
  productInfo: TrackingProductInfo;
  category: TrackingProductCategory;
  attributes: TrackingProductAttributes;
}

interface TrackingProductInfo {
  productName: string;
}

interface TrackingProductAttributes {
  tariffOptions?: TrackingTariffOptions;
  additionalTariffOptions?: TrackingAdditionalTariffOptions;
  insuranceStart?: string;
  productCombination?: TrackingProductCombination;
  tariffOptions1?: string;
  tariffOptions2?: string;
  digitalSignature?: string;
}

export enum TrackingProductCombination {
  basic = 'Basis',
  comfort = 'Komfort',
  premium = 'Premium',
}

export interface TrackingTariffOptions {
  Rechner: TrackingTarifName;
  Bedarfsanalyse?: TrackingNeed;
  VersSum?: number;
  VersLZ?: number;
  VersSumEJ?: number;
  VersSumLJ?: number;
  Dynamik?: TrackingBoolean;
  DrDi?: TrackingBoolean;
  SiPlus?: TrackingBoolean;
  Zahlung?: TrackingPaymentInterval;
  BezugsrechtAend?: number;
  KeweEmail?: string;
  KeweTel?: string;
}

export enum TrackingTarifName {
  RLV = 'risikolv',
}

export enum TrackingPaymentInterval {
  MONTHLY = '1/12',
  QUARTERLY = '1/4',
  BIANNUAL = '1/2',
  YEARLY = '1/1',
}

export interface TrackingAdditionalTariffOptions {
  Rechner: TrackingTarifName;
  RauchS?: TrackingSmokerValues;
  KGroesse?: string;
  KGewicht?: string;
  MotorradF?: TrackingBoolean;
  BezugrechtAend?: number;
}

export enum TrackingSmokerValues {
  smoker = 'R',
  nonSmokerOneYear = 'NRless10',
  nonSmokerTenYears = 'NRmin10',
}

interface TrackingProductCategory {
  primaryCategory: string;
}

interface TrackingTransaction {
  transactionID: string;
  attributes?: TrackingTransactionAttributes;
  total?: {
    transactionTotal?: number;
  };
}

interface TrackingTransactionAttributes {
  conversionType?: TrackingConversionTypes;
  calculatedValue?: number;
}

interface TrackingEventDetails {
  clickType: 'other';
  clickedElement?: TrackingElement;
}

interface TrackingUser {
  profile: TrackingUserProfile;
}

interface TrackingUserProfile {
  attributes: TrackingUserAttributes;
  address?: TrackingUserAddress;
  profileInfo?: TrackingProfileInfo;
}

export interface TrackingUserContact {
  address: TrackingUserAddress;
  profileInfo: TrackingProfileInfo;
}

export interface TrackingUserAttributes {
  insuredIsInsuredPerson?: TrackingBoolean;
  birthday?: string;
  jobTitle?: string;
  occupationalGroup?: string;
  smokerNonSmoker?: TrackingSmoker;
  gender?: TrackingGender;
}

export type TrackingUserAddress = { [key in 'line1' | 'city' | 'country']?: string };
export type TrackingProfileInfo = {
  [key in 'email' | 'telephone' | 'telephoneE164' | 'firstName' | 'lastName']?: string;
};

export enum TrackingSmoker {
  SMOKER = 'Raucher',
  NONSMOKER = 'Nichtraucher',
}

export interface TrackingPageLoadData {
  pageName?: string;
  conversionType?: TrackingConversionTypes;
}
export interface TrackingClickEventData {
  clickedElement: TrackingElement;
}

export enum TrackingElementDUWDisclosure {
  CHECKBOX_DUTY_OF_DISCLOSURE = 'Checkbox_Anzeigepflicht',
  LINK_INFORMATION_VIOLATION_OF_DUTY = 'Link_MitteilungVVG',
}
